import Vue from "vue";
import Vuex from "vuex";

import adChecker from "@lab/store/ad.check.module";
import dashboard from "@lab/store/dashboard";
import datalayer from "@lab/store/datalayer.module";
import form from "@lab/store/form";
import googleMaps from "@lab/store/googleMaps";
import meta from "@lab/store/meta";
import reportFilters from "@lab/store/report.filters.module";
import reportQueries from "@lab/store/report.queries.module";
import reportRequests from "@lab/store/report.requests.module";
import userConfigModule from "@lab/store/user.config.module";
import searchModule from "./modules/search.module";

import authentication from "./modules/authentication.module";
import userModule from "./modules/user/current.module";

import autoEmails from "./modules/old/autoEmails";
import baseUserModule from "./modules/user/base.module";
import bulkeditModule from "./modules/bulkedit.module";
import dailydataUser from "./modules/user/data.module";
import datamapModule from "./modules/dashboard.module";
import datamapCharts from "./modules/dashboard.charts.module";
import datamapsModule from "./modules/dashboards.module";
import editorHeader from "./modules/old/editorHeader";
import groups from "./modules/old/groups";
import healthservices from "./modules/old/healthservices.module";
import healthServiceModule from "./modules/health.service.module";
import homecareproviderModule from "./modules/old/homecare.provider.module";
import homecareproviders from "./modules/old/homecareproviders";
import hospitals from "./modules/old/hospitals";
import hospitalsGroupsModule from "./modules/old/hospitals.groups.module";
import hospitalsModule from "./modules/hospitals.module";
import hospitalModule from "./modules/hospital.module";
import hospitalUser from "./modules/user/hospital.module";
import hospitalUsers from "./modules/old/hospitalUsers";
import listingNotificationGroups from "./modules/old/listingNotificationGroup";
import listingRooms from "./modules/old/listingRooms";
import listings from "./modules/old/listings";
import listingModule from "./modules/listing";
import listingShortlist from "./modules/old/listingShortlist";
import listingUsers from "./modules/old/listingUsers";
import meetingModule from "./modules/meeting.module";
import meetingsModule from "./modules/meetings.module";
import organisationListings from "./modules/old/organisationListings";
import organisations from "./modules/old/organisations";
import organisationsModule from "./modules/organisations.module";
import organisationModule from "./modules/old/organisation.module";
import organisationUser from "./modules/user/organisation.module";
import organisationListingsModule from "./modules/organisation.listings.module";
import organisationUsers from "./modules/old/organisationUsers";
import quickeditModule from "./modules/old/quickedit.module";
import room from "./modules/old/room";
import rooms from "./modules/old/rooms";
import services from "./modules/old/services";
import tabs from "./modules/old/tabs";
import userDashboards from "./modules/old/userDashboards";
import userGroups from "./modules/old/userGroups";
import userinterface from "./modules/old/userinterface";
import userListings from "./modules/old/userListings";
import users from "./modules/old/users";
import usersModule from "./modules/users.module";
import usersModuleOld from "./modules/old/users.module";
import vacancytype from "./modules/old/vacancytype";

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		authentication,
		baseUserModule,
		userModule,
		adChecker,
		autoEmails,
		bulkeditModule,
		dailydataUser,
		dashboard,
		datamapModule,
		datamapCharts,
		datamapsModule,
		datalayer,
		editorHeader,
		form,
		googleMaps,
		groups,
		healthservices,
		healthServiceModule,
		homecareproviders,
		homecareproviderModule,
		hospitalModule,
		hospitals,
		hospitalsGroupsModule,
		hospitalsModule,
		hospitalUser,
		hospitalUsers,
		listingNotificationGroups,
		listingRooms,
		listings,
		listingModule,
		listingShortlist,
		listingUsers,
		meetingModule,
		meetingsModule,
		meta,
		organisationListings,
		organisationListingsModule,
		organisationModule,
		organisations,
		organisationsModule,
		organisationUser,
		organisationUsers,
		quickeditModule,
		reportFilters,
		reportQueries,
		reportRequests,
		room,
		rooms,
		searchModule,
		services,
		tabs,
		userConfigModule,
		userDashboards,
		userGroups,
		userinterface,
		userListings,
		users,
		usersModule,
		usersModuleOld,
		vacancytype
	}
});

export default store;
